import { Dispatch, SetStateAction } from 'react';
import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import Button from '@components/shared/Button';
import OnlyInMobile from '@components/shared/OnlyInMobile';
import { CurrentUser } from '@root/types';
import OnlyInDesktopTablet from '@components/shared/OnlyInDesktopTablet';
import TourbookInfoContent from './TourbookInfoContent';
import ProfessionalInfoContent from './ProfessionalInfoContent';
import s from '../AccountSettings.module.less';
import { AccountSettingsTab } from '../AccountSettings';

type Props = {
  currentUser: CurrentUser | null;
  currentTab: AccountSettingsTab;
  setEditableState: Dispatch<
    SetStateAction<{ professionalInfo: boolean; tourbookContactInfo: boolean }>
  >;
};

const SettingsDisplay = ({ currentUser = null, currentTab, setEditableState }: Props) => {
  const { t } = useTranslation('accountSettings');

  if (!currentUser) return null;

  const headerTranslations = {
    professional_info: 'professionalInfoTitle',
    tourbook_contact_info: 'tourbookInfoTitle',
  };

  const onEditButtonClick = () => {
    setEditableState(prevState => {
      const newState = { ...prevState };
      newState[currentTab] = true;
      return newState;
    });
  };

  return (
    <>
      <OnlyInMobile>
        <Divider className={s.sectionDivider} />
      </OnlyInMobile>
      <div className={s.infoHeader}>
        <h2 className={s.professionalInfoTitle}>{t(headerTranslations[currentTab])}</h2>
        <Button className={s.editStateButton} onClick={onEditButtonClick} title="editButton">
          {t('editButtonLabel')}
        </Button>
      </div>
      <OnlyInDesktopTablet>
        <Divider className={s.sectionDivider} />
      </OnlyInDesktopTablet>
      {currentTab === 'professional_info' && <ProfessionalInfoContent currentUser={currentUser} />}
      {currentTab === 'tourbook_contact_info' && <TourbookInfoContent currentUser={currentUser} />}
    </>
  );
};

export default SettingsDisplay;
